var React = require('react');

function ArrowSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.9,217.3l322.8,0c0.1,0,0.1,0.1,0.1,0.2l-77,77.1c-6.8,6.8-6.8,17.7,0,24.5c6.8,6.8,17.7,6.8,24.5,0l106.8-106.8 c6.8-6.8,6.8-17.7,0-24.5L288.2,81c-3.4-3.4-7.8-5.1-12.2-5.1s-8.9,1.7-12.2,5.1c-6.8,6.8-6.8,17.7,0,24.5l77,77.1 c0.1,0.1,0,0.2-0.1,0.2H17.3c-9.1,0-16.5,7-17.3,15.8C-0.8,208.8,7.6,217.3,17.9,217.3z"}));
}

ArrowSmall.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 400 400","style":{"enableBackground":"new 0 0 400 400","width":"16px","height":"16px"},"xmlSpace":"preserve"};

module.exports = ArrowSmall;

ArrowSmall.default = ArrowSmall;
